export default "__VITE_ASSET__D6jV6UeQ__"